import React, { useEffect, useState } from "react"
import {
  GridColDef,
  GridColumnMenuContainer,
  GridColumnMenuProps,
  GridColumnsMenuItem,
  GridFilterMenuItem,
  GridSelectionModel,
  GridSortModel,
  GridToolbarColumnsButton,
  GridToolbarContainer,
  GridToolbarExport,
  GridToolbarFilterButton,
  HideGridColMenuItem,
  SortGridMenuItems,
} from "@mui/x-data-grid"
import { DataGridPro, useGridApiRef } from "@mui/x-data-grid-pro";
import { RiExpandUpDownLine } from "react-icons/ri"
import { Box, IconButton, LinearProgress, Menu, MenuItem, Typography, useMediaQuery, useTheme } from "@mui/material"
import { MenuDropdown } from "../Elements/MenuDropdown"
import { FileDownload } from "@mui/icons-material"
import { getRowsPerPageOptions } from "../AddEdit/CustomFunctions"
import useAuth from "../../context/AuthProvider"
import moment from "moment"
import Swal from "sweetalert2"
import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
import formatPrice from "../../helper/currencyFormatter"
import { formatUtcToLocal } from "../../helper/utils"
import { buildReportDocumentFilename } from "../../helper/reportDocumentFilename"
import { StateReportsBillingModel } from "../../models/StateReportsBillingModel"
import { StateReportModel_Resp } from "../../models/StateReportModel"
import { EditStateReport } from "../AddEdit/EditStateReport"
import { apiClient } from "../../helper/api"
import { KeyboardArrowDown, KeyboardArrowUp } from "@mui/icons-material"
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import MoreVertOutlinedIcon from "@mui/icons-material/MoreVertOutlined";

interface Iprops {
  listData: StateReportsBillingModel[]
  loadingData: boolean
  setItemList: React.Dispatch<React.SetStateAction<StateReportsBillingModel[]>>
  setFilterModel: any
  setSortModel: any
  sortModel: GridSortModel
  selectedMonth: string
  selectedYear: string
  selectedTab: number
  pageSize: number
  setPageSize: React.Dispatch<React.SetStateAction<number>>
  currentPage: number
  setCurrentPage: React.Dispatch<React.SetStateAction<number>>
  totalCount: number
  selectedPartner: string
  selectedPartnerDisplayName?: string
  billingCompanyRollup?: number
  fetchStateReportBillingData: (pageSize: number, currentPage: number) => Promise<StateReportsBillingModel[]>
}

export const StateReportBillingList: React.FC<Iprops> = ({
  listData,
  loadingData,
  setItemList,
  setFilterModel,
  setSortModel,
  sortModel,
  selectedMonth,
  selectedYear,
  selectedTab,
  pageSize,
  setPageSize,
  currentPage,
  setCurrentPage,
  totalCount,
  selectedPartner,
  selectedPartnerDisplayName,
  billingCompanyRollup = 1,
  fetchStateReportBillingData
}) => {
  const { user } = useAuth()
  const [selectedRows, setSelectedRows] = useState<StateReportsBillingModel[]>()
  const [OpenEdit, setOpenEdit] = React.useState(false);
  const theme = useTheme();
  const isTabletOrDown = useMediaQuery(theme.breakpoints.down("md"));
  const stateReportBillingGridApiRef = useGridApiRef();

  const [dataLoaded, setDataLoaded] = React.useState(false);
  const [isLoading, setIsLoading] = React.useState(true);

  useEffect(() => {
      if (listData?.length > 0 || loadingData) {
          setDataLoaded(true);
      }
  }, [listData, loadingData]);

  useEffect(() => {
      if (dataLoaded) {
          setIsLoading(false);
      }
  }, [dataLoaded]);

  const onRowsSelectionHandler = (ids: GridSelectionModel) => {
    const selectedIDs = new Set(ids)
    const selectedRowData = listData.filter(
      (row) => selectedIDs.has(row?.rowNum ?? "")
    )
    setSelectedRows(selectedRowData)
  }

  const initialLBData: StateReportModel_Resp = {
    stateReportModel_Respdata: [],
    largeReport: undefined,
    completedPage: undefined,
    totalCount: 0,
    pageCount: 0,
    pageSize: 25,
    currentPage: 0

  };

  useEffect(() => {
    setSelectedRows([])
  }, [selectedTab])

  const handleEdit = (ILobData: StateReportsBillingModel) => {
    setFormData(ILobData);
    setOpenEdit(true);
  };

  const handleClose = () => {
    setOpenEdit(false);
  };

  const handleSubmitAndRefresh = async () => {
    // Refresh the data first, then close the dialog
    const refreshedData = await fetchStateReportBillingData(pageSize, currentPage);
    setItemList(refreshedData);
    setOpenEdit(false);
  };

  const initialFormData: StateReportsBillingModel = {
    rowNum: '',
    scheduleId: 0,
    stateReportId: 0,
    stateName: '',
    licensee: '',
    reportName: '',
    dueDate: '',
    period: '',
    payment: false,
    paymentType: '',
    mainLicensee: false,
    reportRequired: false,
    stateId: '',
    license: '',
    dateFinal: '',
    isPaymentRequired: false,
    isReportRequired: false,
    licenseMain: false,
    premiumReport: false,
    feeDue: '',
    partnerName: '',
    state: '',
    largeReport: false,
    largeReportFee: ''
  };
  const [Formdata, setFormData] = React.useState<StateReportsBillingModel>(initialFormData);

  const printDataExcel = async () => {
    // Fix issue #2: Remove pagination limit to get all records
    let dataToPrint = selectedRows && selectedRows.length > 0 ? selectedRows : await fetchStateReportBillingData(10000, 1);
    let grandTotalFeeDue = 0;
    try {
      const workbook = new ExcelJS.Workbook();
      const response = await fetch('/assets/brand/StateReportBillingTemplate.xlsx');
      const arrayBuffer = await response.arrayBuffer();
      await workbook.xlsx.load(arrayBuffer);
      const worksheet = workbook.getWorksheet(1);
      if (!worksheet) return alert("Something went wrong");

      // Clear the template content and start fresh
      worksheet.eachRow((row, rowNumber) => {
        if (rowNumber <= 10) { // Clear first 10 rows to remove logo and template content
          row.eachCell((cell, colNumber) => {
            cell.value = null;
            cell.fill = { type: 'pattern', pattern: 'none' };
            cell.font = {};
            cell.border = {};
          });
        }
      });

      let rowIndex = 1; // Start from row 1 since we cleared the template
      let filteredColumns = Columns.filter(col =>
        col.headerName
        && col.headerName !== 'No'
        && col.headerName !== 'Edit'
        && col.headerName !== 'startDate'
        && col.headerName !== 'endDate'
        && col.field !== 'stateRule'
      )
      if (selectedTab === 1) {
        filteredColumns = filteredColumns.filter(col => 
          col.headerName !== 'Date Completed' && 
          col.headerName !== 'Large Report' &&
          col.headerName !== 'First Request' &&
          col.headerName !== 'Second Request' &&
          col.headerName !== 'Third Request' && 
          col.headerName !== 'NotesToClient' &&
          col.headerName !== 'Tax Reported' && 
          col.headerName !== 'Fee Due' &&
          col.headerName !== 'Main Licensee'
        );
      }
      if (selectedTab === 2) {
        filteredColumns = filteredColumns.filter(col => 
          col.headerName !== 'First Request' &&
          col.headerName !== 'Second Request' &&
          col.headerName !== 'Third Request' && 
          col.headerName !== 'Wet Signature Required' &&
          col.headerName !== 'Notary Stamp Required'
        );
      }
      if (selectedTab === 3) {
        filteredColumns = filteredColumns.filter(col => 
          col.headerName !== 'Date Completed' &&  
          col.headerName !== 'Wet Signature Required' &&
          col.headerName !== 'Notary Stamp Required'
        );
      }
      const isExcelVisibleColumn = (col: GridColDef) => {
        if (col.field === 'largeReport' || col.field === 'largeReportFee') {
          return true;
        }
        if (selectedTab === 1 && (col.field === 'notaryStamp' || col.field === 'wetSignature')) {
          return true;
        }
        return !col.hide;
      };
      filteredColumns = filteredColumns.filter(isExcelVisibleColumn);
      // Fix issue #1: Set correct title based on selected tab
      const getReportTitle = () => {
        switch (selectedTab) {
          case 1: return 'Upcoming State Reports and Payments';
          case 2: return 'Completed State Reports and Payments';
          case 3: return 'Outstanding State Reports and Payments';
          default: return 'State Reports and Payments';
        }
      };

      // Fix issue #3: Remove state grouping, show transactions in filter order
      const stateColumnIndex = filteredColumns.findIndex(col => col.headerName === 'state');
      if (stateColumnIndex !== -1) filteredColumns.unshift(filteredColumns.splice(stateColumnIndex, 1)[0]);
      const columnHeaders = filteredColumns.map(col => col.headerName);

      const addHeaderRow = (rowIdx: number) => {
        const headerRow = worksheet.getRow(rowIdx);
        columnHeaders.forEach((header, colIndex) => {
          const cell = headerRow.getCell(colIndex + 1);
          cell.value = header;
          cell.font = { bold: true };
          cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: '808080' } };
        });
        return rowIdx + 1;
      };

      const getCompanyName = () => {
        if (selectedPartner === '0' || !selectedPartner) {
          return 'All';
        }
        const fromSelection = (selectedPartnerDisplayName || '').trim();
        if (fromSelection) return fromSelection;
        return dataToPrint[0]?.partnerName || 'All';
      };

      // Set the report title (no "Filed Transactions" - just the correct title)
      worksheet.getRow(rowIndex).getCell(2).value = getReportTitle();
      worksheet.getRow(rowIndex).getCell(2).font = { bold: true, size: 16 };
      rowIndex++;

      // Set the company name
      worksheet.getRow(rowIndex).getCell(2).value = `Company: ${getCompanyName()}`;
      worksheet.getRow(rowIndex).getCell(2).font = { bold: true, size: 14 };
      rowIndex += 2;

      // Add header row
      rowIndex = addHeaderRow(rowIndex);

      // Process all data in order (no grouping by client or state)
      let colorCycleIndex = 0;
      dataToPrint.forEach((row) => {
        filteredColumns.forEach((col, colIndex) => {
          let value = (row as any)[col.field];
          if (col.field === "payment" || col.field === "reportRequired" || col.field === "mainLicensee" || col.field ==='notaryStamp' || col.field ==='wetSignature') value = value ? "true" : "false";
          else if (col.field === 'dateFinalReportSentToClient') value = value ? formatUtcToLocal(value, "MM/DD/YYYY") : '';
          else if (col.field == 'taxReported' || col.field == 'taxAmount' || col.field == 'largeReportFee') value = formatPrice(value);
          else if (col.field == 'largeReport') value = String(value).toLowerCase() === 'true' || value === true ? 'Yes' : 'No';
          else value = value !== undefined && value !== null ? value : "";

          if (col.field === 'feeDue') {
            const fee = parseFloat(value) || 0;
            grandTotalFeeDue += fee;
          }

          const cell = worksheet.getRow(rowIndex).getCell(colIndex + 1);

          cell.value = (col.field === "feeDue") ? Number(value) : value;
          if (col.field === "feeDue") cell.numFmt = '"$"#,##0.00';
          const fillColors = ['FFFFFF', 'ededed', 'd9d9d9'];
          const fillColor = fillColors[colorCycleIndex % 3];
          cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: fillColor } };
        });

        rowIndex++;
        colorCycleIndex++; // Increment to apply the next color in the cycle
      });
      // if (selectedTab == 1){
      //   worksheet.getCell(`I${rowIndex}`).value = 'Total Fee Due';
      //   worksheet.getCell(`I${rowIndex}`).font = { bold: true, size: 15, color: { argb: "FF0000" } };
      //   worksheet.getCell(`J${rowIndex}`).value = grandTotalFeeDue;
      //   worksheet.getCell(`J${rowIndex}`).numFmt = '"$"#,##0.00';
      //   worksheet.getCell(`J${rowIndex}`).font = { bold: true, size: 15, color: { argb: "FF0000" } };
      // }
      // else
       if (selectedTab == 3){
        worksheet.getCell(`O${rowIndex}`).value = 'Total Fee Due';
        worksheet.getCell(`O${rowIndex}`).font = { bold: true, size: 15, color: { argb: "FF0000" } };
        worksheet.getCell(`P${rowIndex}`).value = grandTotalFeeDue;
        worksheet.getCell(`P${rowIndex}`).numFmt = '"$"#,##0.00';
        worksheet.getCell(`P${rowIndex}`).font = { bold: true, size: 15, color: { argb: "FF0000" } };
      }
      else if(selectedTab == 2) {
      worksheet.getCell(`M${rowIndex}`).value = 'Total Fee Due';
      worksheet.getCell(`M${rowIndex}`).font = { bold: true, size: 15, color: { argb: "FF0000" } };
      worksheet.getCell(`N${rowIndex}`).value = grandTotalFeeDue;
      worksheet.getCell(`N${rowIndex}`).numFmt = '"$"#,##0.00';
      worksheet.getCell(`N${rowIndex}`).font = { bold: true, size: 15, color: { argb: "FF0000" } };
      }

      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      saveAs(blob, buildReportDocumentFilename({
        month: selectedMonth,
        year: selectedYear,
        clientName: selectedPartnerDisplayName || 'All Clients',
        reportType: selectedTab === 1 ? 'upcoming' : selectedTab === 3 ? 'outstanding' : 'completed',
        extension: 'xlsx',
      }));
    } catch (error) {
      console.error("Error generating the Excel file:", error);
    }
  };

  const printDataPdf = async () => {
    console.log('🖨️ STATE REPORTS BILLING PDF PRINT CLICKED - Starting PDF generation...');
    
    // State Reports Billing: Use server-side PDF generation
    try {
      const token = user?.token;
      
      // Log user context and current state
      console.log('🔍 USER CONTEXT:', {
        userId: user?.userId,
        userRoles: user?.userRoles,
        token: token ? 'Present' : 'Missing'
      });
      
      console.log('🔍 CURRENT UI STATE:', {
        selectedPartner: selectedPartner,
        selectedMonth: selectedMonth,
        selectedYear: selectedYear,
        selectedTab: selectedTab,
        tabName: selectedTab === 1 ? 'Upcoming' : selectedTab === 2 ? 'Completed' : selectedTab === 3 ? 'Outstanding' : 'Unknown',
        totalCount: totalCount,
        selectedRowsCount: selectedRows?.length || 0,
        hasSelectedRows: selectedRows && selectedRows.length > 0
      });
      
      // Show loading dialog
      Swal.fire({
        title: 'Generating PDF...',
        text: 'Please wait while we generate your State Reports PDF.',
        allowOutsideClick: false,
        allowEscapeKey: false,
        showConfirmButton: false,
        didOpen: () => {
          Swal.showLoading();
        }
      });

      // Use the dedicated PDF endpoint for all tabs
      const endpoint = '/StateReport/getStateReportBillingPdf';
      
      // Build request payload for the dedicated PDF endpoint
      const requestPayload = {
        PartnerId: selectedPartner || '',
        selectedTab: selectedTab,
        pageSize: 1000,
        currentPage: 1,
        field: 'dueDate',
        sort: 'asc',
        fieldName: '',
        value: '',
        operator: '',
        userTimezone: 'America/Denver',
        // Use month/year for all tabs (no date range)
        useDateRange: false,
        month: selectedMonth,
        year: selectedYear,
        companyRollup: billingCompanyRollup,
      };
      
      // Build the comprehensive request object for logging
      const fullRequestObject = {
        url: endpoint,
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: requestPayload
      };

      // Log the complete request with full authorization token for debugging
      console.log('=== STATE REPORTS BILLING PDF REQUEST DEBUG ===');
      console.log('🔍 ENDPOINT:', fullRequestObject.url);
      console.log('🔍 METHOD:', fullRequestObject.method);
      console.log('🔍 HEADERS:', JSON.stringify(fullRequestObject.headers, null, 2));
      console.log('🔍 FULL AUTHORIZATION TOKEN:', token);
      console.log('🔍 REQUEST BODY:', JSON.stringify(fullRequestObject.body, null, 2));
      console.log('🔍 REQUEST SIZE:', JSON.stringify(fullRequestObject.body).length + ' characters');
      console.log('🔍 READY-TO-USE cURL COMMAND:');
      console.log(`curl -X POST "${window.location.origin}${fullRequestObject.url}" \\`);
      console.log(`  -H "Content-Type: application/json" \\`);
      console.log(`  -H "Authorization: Bearer ${token}" \\`);
      console.log(`  -d '${JSON.stringify(fullRequestObject.body)}'`);
      console.log('=== END REQUEST LOG ===');

      const responseJson = await apiClient(endpoint, {
        method: "POST",
        headers: new Headers({
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        }),
        body: JSON.stringify(requestPayload),
      });

      Swal.close();

      // Log the full response for debugging
      console.log('=== STATE REPORTS BILLING PDF API RESPONSE DEBUG ===');
      console.log('📥 FULL RESPONSE OBJECT:', responseJson);
      console.log('📥 RESPONSE TYPE:', typeof responseJson);
      console.log('📥 RESPONSE KEYS:', responseJson ? Object.keys(responseJson) : 'No response');
      console.log('📥 RESPONSE STATUS INDICATORS:');
      console.log('   - responseJson.status:', responseJson?.status);
      console.log('   - responseJson.success:', responseJson?.success);
      console.log('   - responseJson.data:', responseJson?.data);
      console.log('   - responseJson.message:', responseJson?.message);
      console.log('   - responseJson.error:', responseJson?.error);
      if (responseJson?.data) {
        console.log('📥 RESPONSE DATA ANALYSIS:');
        console.log('   - data type:', typeof responseJson.data);
        console.log('   - data keys:', Object.keys(responseJson.data));
        console.log('   - pdf_url present:', !!responseJson.data.pdf_url);
        console.log('   - filename present:', !!responseJson.data.filename);
        console.log('   - pdf_url value:', responseJson.data.pdf_url);
        console.log('   - filename value:', responseJson.data.filename);
        console.log('   - original_data_count:', responseJson.data.original_data_count);
      }
      console.log('=== END RESPONSE DEBUG ===');

      if (!responseJson) {
        console.log('❌ ERROR: No response received from server');
        Swal.fire({
          title: 'Error!',
          text: 'Failed to get response from server.',
          icon: 'error',
          confirmButtonColor: '#02A4E3'
        });
        return;
      }

      // Handle server-side PDF generation response
      if (responseJson.status && responseJson.data && responseJson.data.pdf_url) {
        // Download PDF from the provided URL
        const link = document.createElement('a');
        link.href = responseJson.data.pdf_url;
        link.download = responseJson.data.filename || 'state-reports-billing.pdf';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        // Show success message
        Swal.fire({
          title: 'Success!',
          text: `PDF downloaded successfully! ${responseJson.data.original_data_count || 0} records processed.`,
          icon: 'success',
          confirmButtonColor: '#02A4E3',
          timer: 3000,
          timerProgressBar: true
        });
      } else {
        // API did not return expected response
        console.error('❌ API Response Error: Expected pdf_url in response');
        Swal.fire({
          title: 'Error!',
          text: 'Failed to generate PDF. Please try again or contact support.',
          icon: 'error',
          confirmButtonColor: '#02A4E3'
        });
      }
    } catch (error) {
      console.error("❌ Server-side PDF generation failed:", error);
      Swal.close();
      Swal.fire({
        title: 'Error!',
        text: 'An error occurred while generating the PDF. Please try again.',
        icon: 'error',
        confirmButtonColor: '#02A4E3'
      });
    }
  };


  const printData = (option: string) => {
    console.log('📋 STATE REPORTS BILLING PRINT OPTION SELECTED:', {
      option: option,
      currentPage: window.location.href,
      selectedTab: selectedTab,
      tabName: selectedTab === 1 ? 'Upcoming' : selectedTab === 2 ? 'Completed' : selectedTab === 3 ? 'Outstanding' : 'Unknown',
      selectedRowsCount: selectedRows?.length || 0,
      totalDataCount: totalCount,
      selectedPartner: selectedPartner,
      selectedMonth: selectedMonth,
      selectedYear: selectedYear
    });
    
    if (option === 'excel') {
      printDataExcel();
    } else if (option === 'pdf') {
      printDataPdf();
    } else {
      console.log('⚠️ WARNING: Invalid print option selected:', option);
      Swal.fire({
        icon: 'warning',
        title: 'No option selected',
        text: 'Please select an option to proceed.',
      });
    }
  };

  function CustomToolbar() {
    return (
      <GridToolbarContainer>
        <GridToolbarFilterButton className="me-3 sky-blue" />
        <GridToolbarColumnsButton className="me-3 sky-blue" />
        <GridToolbarExport className="me-3 sky-blue" />
      </GridToolbarContainer>
    );
  }

  function CustomColumnMenu(props: GridColumnMenuProps) {
    const { hideMenu, currentColumn, ...other } = props;
    return (
      <GridColumnMenuContainer hideMenu={hideMenu} currentColumn={currentColumn} {...other}>
        <SortGridMenuItems onClick={hideMenu} column={currentColumn} />
        <GridFilterMenuItem onClick={hideMenu} column={currentColumn} />
        <HideGridColMenuItem onClick={hideMenu} column={currentColumn} />
        <GridColumnsMenuItem onClick={hideMenu} column={currentColumn} />
      </GridColumnMenuContainer>
    );
  }

  const printOptions = selectedPartner !== "0" ? ["Excel", "PDF"] : ["Excel"];

  function EditToolbar() {
    const [toolbarMenuAnchor, setToolbarMenuAnchor] = useState<null | HTMLElement>(null);
    const openToolbarMenu = Boolean(toolbarMenuAnchor);

    const handleToolbarMenuClose = () => setToolbarMenuAnchor(null);
    const handleToolbarAction = (action: "filter" | "columns" | "exportCsv" | "exportPrint" | "exportExcel") => {
      handleToolbarMenuClose();
      const api = stateReportBillingGridApiRef.current;
      if (!api) return;
      if (action === "filter") api.showFilterPanel();
      else if (action === "columns") (api as any).showPreferences("columns");
      else if (action === "exportCsv") api.exportDataAsCsv();
      else if (action === "exportPrint") api.exportDataAsPrint();
    };

    return (
      <Box sx={{ display: "flex", flexWrap: "wrap", alignItems: "center", justifyContent: "space-between", gap: 1.5, py: 1.5, px: 1 }}>
        <Typography variant="subtitle1" fontWeight={600} sx={{ color: "#334155", mr: "auto", pl: 1 }}>
          State Reports Billing
        </Typography>
        <Box sx={{ display: "flex", alignItems: "center" }}>
          {isTabletOrDown ? (
            <>
              <IconButton
                aria-label="Table options"
                aria-controls={openToolbarMenu ? "table-options-menu" : undefined}
                aria-haspopup="true"
                aria-expanded={openToolbarMenu ? "true" : undefined}
                onClick={(e) => setToolbarMenuAnchor(e.currentTarget)}
                sx={{ color: "#2099d2" }}
              >
                <MoreVertOutlinedIcon />
              </IconButton>
              <Menu
                id="table-options-menu"
                anchorEl={toolbarMenuAnchor}
                open={openToolbarMenu}
                onClose={handleToolbarMenuClose}
                MenuListProps={{ "aria-labelledby": "table-options-button" }}
                anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                transformOrigin={{ vertical: "top", horizontal: "right" }}
              >
                <MenuItem onClick={() => handleToolbarAction("filter")}>Filter</MenuItem>
                <MenuItem onClick={() => handleToolbarAction("columns")}>Columns</MenuItem>
                <MenuItem onClick={() => handleToolbarAction("exportCsv")}>Download as CSV</MenuItem>
                <MenuItem onClick={(item) => printData("excel")}>Export Excel</MenuItem>
                <MenuItem onClick={() => handleToolbarAction("exportPrint")}>Print</MenuItem>
              </Menu>
            </>
          ) : (
            <CustomToolbar />
          )}
        </Box>
        { !isTabletOrDown && (
          <Box sx={{ display: "flex", alignItems: "center", gap: 1, flexWrap: "wrap", zIndex: 9 }}>
            <MenuDropdown
              menuTitle="Print"
              items={printOptions}
              onItemClick={(item) => printData(item.toLowerCase())}
              sx={{
                textTransform: "none",
                fontWeight: 600,
                backgroundColor: "#2099d2",
                "&:hover": { backgroundColor: "#176990" },
                px: 2,
              }}
              startIcon={<FileDownload />}
            />
          </Box>
        )}
      </Box>
    );
  }

  const Columns: GridColDef[] = [
    {
      field: 'paymentFilingScheduleId',
      type: 'number',
      headerName: 'No',
      hide: true,
      hideable: false,
      disableExport: true,
    },
    {
      field: 'stateRule',
      flex: 0.4,
      headerName: "Edit",
      minWidth: 70,
      hideSortIcons: true,
      align: 'left',
      headerAlign: 'left',
      renderCell: (params) => (
        <div>
          <IconButton
            color="primary"
            sx={{ color: 'rgba(255,255,255,0.9)', '&:hover': { color: '#fff', backgroundColor: 'rgba(32,153,210,0.15) !important' } }}
            onClick={() => {
              handleEdit(params.row);
            }}
            disabled={false}
          >
            <EditOutlinedIcon fontSize="small" color="primary" />
          </IconButton>
        </div>
      ),
    },
    {
      field: "stateName",
      type: "text",
      headerName: "State",
      minWidth: 100,
      headerAlign: "left",
      align: "left",
      hideSortIcons: true,
      renderHeader: (params) => {
        const sortItem = sortModel.find(
            (item: any) => item.field === 'stateName'
          );
    
        const isSortedAsc = sortItem?.sort === 'asc';
        const isSortedDesc = sortItem?.sort === 'desc'
        return (
            <div>
                <span className="table-card-title">{params.colDef.headerName}</span>
                {isSortedAsc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px', color: '#999999'}} /></span> : isSortedDesc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px', color: '#999999'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px'}} /></span> : <span className=""><RiExpandUpDownLine /></span>}
            </div>
        )
      },
      valueGetter: (params) => params.value,
    },
    {
      field: "reportName",
      type: "text",
      headerName: "Report Name",
      minWidth: 200,
      headerAlign: "left",
      align: "left",
      hideSortIcons: true,
      renderHeader: (params) => {
        const sortItem = sortModel.find(
            (item: any) => item.field === 'reportName'
          );
    
        const isSortedAsc = sortItem?.sort === 'asc';
        const isSortedDesc = sortItem?.sort === 'desc'
        return (
            <div>
                <span className="table-card-title">{params.colDef.headerName}</span>
                {isSortedAsc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px', color: '#999999'}} /></span> : isSortedDesc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px', color: '#999999'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px'}} /></span> : <span className=""><RiExpandUpDownLine /></span>}
            </div>
        )
      },
      valueGetter: (params) => params.value,
    },
    {
      field: "period",
      type: "text",
      headerName: "Period",
      minWidth: 200,
      headerAlign: "left",
      align: "left",
      hideSortIcons: true,
      renderHeader: (params) => {
        const sortItem = sortModel.find(
            (item: any) => item.field === 'period'
          );
    
        const isSortedAsc = sortItem?.sort === 'asc';
        const isSortedDesc = sortItem?.sort === 'desc'
        return (
        <div>
          <span className="table-card-title">{params.colDef.headerName}</span>
          {isSortedAsc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px', color: '#999999'}} /></span> : isSortedDesc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px', color: '#999999'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px'}} /></span> : <span className=""><RiExpandUpDownLine /></span>}
        </div>
        )
      },
    },
    {
      field: "dueDate",
      type: "text",
      headerName: "Due Date",
      minWidth: 140,
      headerAlign: "left",
      align: "left",
      hideSortIcons: true,
      renderHeader: (params) => {
        const sortItem = sortModel.find(
            (item: any) => item.field === 'dueDate'
          );
    
        const isSortedAsc = sortItem?.sort === 'asc';
        const isSortedDesc = sortItem?.sort === 'desc'
        return (
          <div>
            <span className="table-card-title">{params.colDef.headerName}</span>
            {isSortedAsc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px', color: '#999999'}} /></span> : isSortedDesc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px', color: '#999999'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px'}} /></span> : <span className=""><RiExpandUpDownLine /></span>}
          </div>
        )
      },
      valueGetter: (params) =>
        formatUtcToLocal(params.value, "MM/DD/YYYY"),
    },
    {
      field: "paymentType",
      type: "text",
      headerName: "Payment Type",
      minWidth: 170,
      headerAlign: "left",
      align: "left",
      hideSortIcons: true,
      renderHeader: (params) => {
        const sortItem = sortModel.find(
            (item: any) => item.field === 'paymentType'
          );
    
        const isSortedAsc = sortItem?.sort === 'asc';
        const isSortedDesc = sortItem?.sort === 'desc'
        return (
        <div>
          <span className="table-card-title">{params.colDef.headerName}</span>
          {isSortedAsc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px', color: '#999999'}} /></span> : isSortedDesc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px', color: '#999999'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px'}} /></span> : <span className=""><RiExpandUpDownLine /></span>}
        </div>
      )
      },
      valueGetter: (params) => params.value,
    },
    {
      field: "licensee",
      type: "text",
      headerName: "Licensee",
      minWidth: 200,
      headerAlign: "left",
      align: "left",
      hideSortIcons: true,
      renderHeader: (params) => {
        const sortItem = sortModel.find(
            (item: any) => item.field === 'licensee'
          );
    
        const isSortedAsc = sortItem?.sort === 'asc';
        const isSortedDesc = sortItem?.sort === 'desc'
        return (
        <div>
          <span className="table-card-title">{params.colDef.headerName}</span>
          {isSortedAsc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px', color: '#999999'}} /></span> : isSortedDesc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px', color: '#999999'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px'}} /></span> : <span className=""><RiExpandUpDownLine /></span>}
        </div>
      )
      },
      valueGetter: (params) => params.value,
    },
    ((selectedTab === 1 || selectedTab === 3)? {
      field: "dateFinalReportSentToClient",
      type: "text",
      headerName: "Date Completed",
      minWidth: 200,
      headerAlign: "left",
      align: "left",
      hideSortIcons: true,
      hide: true,
      renderHeader: (params) => {
        const sortItem = sortModel.find(
            (item: any) => item.field === 'dateFinalReportSentToClient'
          );
    
        const isSortedAsc = sortItem?.sort === 'asc';
        const isSortedDesc = sortItem?.sort === 'desc'
        return (
        <div>
          <span className="table-card-title">{params.colDef.headerName}</span>
          {isSortedAsc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px', color: '#999999'}} /></span> : isSortedDesc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px', color: '#999999'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px'}} /></span> : <span className=""><RiExpandUpDownLine /></span>}
        </div>
      )
      },
      renderCell: (params) => {
        const dateValue = params.value;
        return dateValue ? formatUtcToLocal(dateValue, "MM/DD/YYYY") : "";
      },
      } : 
      {
        field: "dateFinalReportSentToClient",
        type: "text",
        headerName: "Date Completed",
        minWidth: 200,
        headerAlign: "left",
        align: "left",
        hideSortIcons: true,
        renderHeader: (params) => {
          const sortItem = sortModel.find(
              (item: any) => item.field === 'dateFinalReportSentToClient'
            );
    
          const isSortedAsc = sortItem?.sort === 'asc';
          const isSortedDesc = sortItem?.sort === 'desc'
          return (
          <div>
            <span className="table-card-title">{params.colDef.headerName}</span>
            {isSortedAsc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px', color: '#999999'}} /></span> : isSortedDesc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px', color: '#999999'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px'}} /></span> : <span className=""><RiExpandUpDownLine /></span>}
          </div>
        )
        },
        renderCell: (params) => {
          const dateValue = params.value;
          return dateValue ? formatUtcToLocal(dateValue, "MM/DD/YYYY") : "";
        },
      }
    ),
    {
      field: "payment",
      type: "text",
      headerName: "Payment Required",
      minWidth: 200,
      headerAlign: "left",
      align: "left",
      hideSortIcons: true,
      renderHeader: (params) => {
        const sortItem = sortModel.find(
            (item: any) => item.field === 'payment'
          );
    
        const isSortedAsc = sortItem?.sort === 'asc';
        const isSortedDesc = sortItem?.sort === 'desc'
        return (
        <div>
          <span className="table-card-title">{params.colDef.headerName}</span>
          {isSortedAsc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px', color: '#999999'}} /></span> : isSortedDesc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px', color: '#999999'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px'}} /></span> : <span className=""><RiExpandUpDownLine /></span>}
        </div>
      )
      },
    },
    {
      field: "reportRequired",
      type: "text",
      headerName: "Report Required",
      minWidth: 180,
      headerAlign: "left",
      align: "left",
      hideSortIcons: true,
      renderHeader: (params) => {
        const sortItem = sortModel.find(
            (item: any) => item.field === 'reportRequired'
          );
    
        const isSortedAsc = sortItem?.sort === 'asc';
        const isSortedDesc = sortItem?.sort === 'desc'
        return (
        <div>
          <span className="table-card-title">{params.colDef.headerName}</span>
          {isSortedAsc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px', color: '#999999'}} /></span> : isSortedDesc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px', color: '#999999'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px'}} /></span> : <span className=""><RiExpandUpDownLine /></span>}
        </div>
      )
      },
      valueGetter: (params) => params.value,
      editable: true, // Make the feeDue column editable
    },
    {
      field: "mainLicensee",
      type: "text",
      headerName: "Main Licensee",
      minWidth: 170,
      headerAlign: "left",
      align: "left",
      hideSortIcons: true,
      renderHeader: (params) => {
        const sortItem = sortModel.find(
            (item: any) => item.field === 'mainLicensee'
          );
    
        const isSortedAsc = sortItem?.sort === 'asc';
        const isSortedDesc = sortItem?.sort === 'desc'
        return (
        <div>
          <span className="table-card-title">{params.colDef.headerName}</span>
          {isSortedAsc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px', color: '#999999'}} /></span> : isSortedDesc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px', color: '#999999'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px'}} /></span> : <span className=""><RiExpandUpDownLine /></span>}
        </div>
      )
      },
      valueGetter: (params) => params.value,
      editable: true, // Make the feeDue column editable
    },
    (selectedTab === 3 ?
      {
        field: "firstRequest",
        type: "text",
        headerName: "First Request",
        minWidth: 200,
        headerAlign: "left",
        align: "left",
        hideSortIcons: true,
        renderHeader: (params) => {
          const sortItem = sortModel.find(
              (item: any) => item.field === 'firstRequest'
            );
    
          const isSortedAsc = sortItem?.sort === 'asc';
          const isSortedDesc = sortItem?.sort === 'desc'
          return (
          <div>
            <span className="table-card-title">{params.colDef.headerName}</span>
            {isSortedAsc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px', color: '#999999'}} /></span> : isSortedDesc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px', color: '#999999'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px'}} /></span> : <span className=""><RiExpandUpDownLine /></span>}
          </div>
        )
        },
        valueGetter: (params) => {
          return params.value ? formatUtcToLocal(params.value, "MM/DD/YYYY") : "";
        }
      } :       
      {
      field: "firstRequest",
      type: "text",
      headerName: "First Request",
      minWidth: 200,
      headerAlign: "left",
      align: "left",
      hideSortIcons: true,
      hide: true,
      renderHeader: (params) => {
        const sortItem = sortModel.find(
            (item: any) => item.field === 'firstRequest'
          );
    
        const isSortedAsc = sortItem?.sort === 'asc';
        const isSortedDesc = sortItem?.sort === 'desc'
        return (
        <div>
          <span className="table-card-title">{params.colDef.headerName}</span>
          {isSortedAsc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px', color: '#999999'}} /></span> : isSortedDesc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px', color: '#999999'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px'}} /></span> : <span className=""><RiExpandUpDownLine /></span>}
        </div>
      )
      },
      valueGetter: (params) => {
        return params.value ? formatUtcToLocal(params.value, "MM/DD/YYYY") : "";
      }
      
    } ),
    (selectedTab === 3 ?
      {
        field: "secondRequest",
        type: "text",
        headerName: "Second Request",
        minWidth: 200,
        headerAlign: "left",
        align: "left",
        hideSortIcons: true,
        renderHeader: (params) => {
          const sortItem = sortModel.find(
              (item: any) => item.field === 'secondRequest'
            );
    
          const isSortedAsc = sortItem?.sort === 'asc';
          const isSortedDesc = sortItem?.sort === 'desc'
          return (
          <div>
            <span className="table-card-title">{params.colDef.headerName}</span>
            {isSortedAsc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px', color: '#999999'}} /></span> : isSortedDesc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px', color: '#999999'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px'}} /></span> : <span className=""><RiExpandUpDownLine /></span>}
          </div>
        )
        },
        valueGetter: (params) => {
          return params.value ? formatUtcToLocal(params.value, "MM/DD/YYYY") : "";
        }
        
      } :       
      {
      field: "secondRequest",
      type: "text",
      headerName: "Second Request",
      minWidth: 200,
      headerAlign: "left",
      align: "left",
      hideSortIcons: true,
      hide: true,
      renderHeader: (params) => {
        const sortItem = sortModel.find(
            (item: any) => item.field === 'secondRequest'
          );
    
        const isSortedAsc = sortItem?.sort === 'asc';
        const isSortedDesc = sortItem?.sort === 'desc'
        return (
        <div>
          <span className="table-card-title">{params.colDef.headerName}</span>
          {isSortedAsc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px', color: '#999999'}} /></span> : isSortedDesc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px', color: '#999999'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px'}} /></span> : <span className=""><RiExpandUpDownLine /></span>}
        </div>
      )
      },
      valueGetter: (params) => {
        return params.value ? formatUtcToLocal(params.value, "MM/DD/YYYY") : "";
      }
      
    } ),
    (selectedTab === 3 ?
      {
        field: "thirdRequest",
        type: "text",
        headerName: "Third Request",
        minWidth: 200,
        headerAlign: "left",
        align: "left",
        hideSortIcons: true,
        renderHeader: (params) => {
          const sortItem = sortModel.find(
              (item: any) => item.field === 'thirdRequest'
            );
      
          const isSortedAsc = sortItem?.sort === 'asc';
          const isSortedDesc = sortItem?.sort === 'desc'
          return (
              <div>
                  <span className="table-card-title">{params.colDef.headerName}</span>
                  {isSortedAsc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px', color: '#999999'}} /></span> : isSortedDesc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px', color: '#999999'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px'}} /></span> : <span className=""><RiExpandUpDownLine /></span>}
              </div>
          )
        },
        valueGetter: (params) => {
          return params.value ? formatUtcToLocal(params.value, "MM/DD/YYYY") : "";
        }
        
      } :       
      {
      field: "thirdRequest",
      type: "text",
      headerName: "Third Request",
      minWidth: 200,
      headerAlign: "left",
      align: "left",
      hideSortIcons: true,
      hide: true,
      renderHeader: (params) => {
        const sortItem = sortModel.find(
            (item: any) => item.field === 'thirdRequest'
          );
    
        const isSortedAsc = sortItem?.sort === 'asc';
        const isSortedDesc = sortItem?.sort === 'desc'
        return (
            <div>
                <span className="table-card-title">{params.colDef.headerName}</span>
                {isSortedAsc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px', color: '#999999'}} /></span> : isSortedDesc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px', color: '#999999'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px'}} /></span> : <span className=""><RiExpandUpDownLine /></span>}
            </div>
        )
    },
      valueGetter: (params) => {
        return params.value ? formatUtcToLocal(params.value, "MM/DD/YYYY") : "";
      }
      
    } ),
    (selectedTab === 1 ?
    {
      field: "notes",
      type: "text",
      headerName: "NotesToClient",
      minWidth: 200,
      headerAlign: "left",
      align: "left",
      hideSortIcons: true,
      hide: true,
      renderHeader: (params) => {
        const sortItem = sortModel.find(
            (item: any) => item.field === 'notes'
          );
    
        const isSortedAsc = sortItem?.sort === 'asc';
        const isSortedDesc = sortItem?.sort === 'desc'
        return (
          <div>
            <span className="table-card-title">{params.colDef.headerName}</span>
            {isSortedAsc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px', color: '#999999'}} /></span> : isSortedDesc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px', color: '#999999'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px'}} /></span> : <span className=""><RiExpandUpDownLine /></span>}
          </div>
        )
      },
      valueGetter: (params) => params.value
    } : 
    {
      field: "notes",
      type: "text",
      headerName: selectedTab === 3 ? "Filer Notes" : "Notes To Client",
      minWidth: 200,
      headerAlign: "left",
      align: "left",
      hideSortIcons: true,
      renderHeader: (params) => {
        const sortItem = sortModel.find(
            (item: any) => item.field === 'notes'
          );
    
        const isSortedAsc = sortItem?.sort === 'asc';
        const isSortedDesc = sortItem?.sort === 'desc'
        return (
          <div>
            <span className="table-card-title">{params.colDef.headerName}</span>
            {isSortedAsc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px', color: '#999999'}} /></span> : isSortedDesc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px', color: '#999999'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px'}} /></span> : <span className=""><RiExpandUpDownLine /></span>}
          </div>
        )
      },
      valueGetter: (params) => params.value
    }),
    (selectedTab === 1 ?
      {
        field: "taxAmount",
        type: "text",
        headerName: "Tax Reported",
        minWidth: 200,
        headerAlign: "left",
        align: "left",
        hideSortIcons: true,
        hide: true,
        renderHeader: (params) => {
          const sortItem = sortModel.find(
              (item: any) => item.field === 'taxAmount'
            );
      
          const isSortedAsc = sortItem?.sort === 'asc';
          const isSortedDesc = sortItem?.sort === 'desc'
          return (
              <div>
                  <span className="table-card-title">{params.colDef.headerName}</span>
                  {isSortedAsc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px', color: '#999999'}} /></span> : isSortedDesc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px', color: '#999999'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px'}} /></span> : <span className=""><RiExpandUpDownLine /></span>}
              </div>
          )
        },
        valueGetter: (params) => formatPrice(params.value),
        editable: false,
      } : 
      {
        field: "taxAmount",
        type: "text",
        headerName: "Tax Reported",
        minWidth: 200,
        headerAlign: "left",
        align: "left",
        hideSortIcons: true,
        renderHeader: (params) => {
          const sortItem = sortModel.find(
              (item: any) => item.field === 'taxAmount'
            );
    
          const isSortedAsc = sortItem?.sort === 'asc';
          const isSortedDesc = sortItem?.sort === 'desc'
          return (
              <div>
                  <span className="table-card-title">{params.colDef.headerName}</span>
                  {isSortedAsc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px', color: '#999999'}} /></span> : isSortedDesc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px', color: '#999999'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px'}} /></span> : <span className=""><RiExpandUpDownLine /></span>}
              </div>
          )
        },
        valueGetter: (params) => formatPrice(params.value),
        editable: false,
      } ),
    (selectedTab === 1 ?
    {
      field: "largeReport",
      type: "text",
      headerName: "Large Report",
      minWidth: 200,
      headerAlign: "left",
      align: "left",
      hideSortIcons: true,
      hide: true,
      renderHeader: (params) => {
        const sortItem = sortModel.find(
            (item: any) => item.field === 'largeReport'
          );
    
        const isSortedAsc = sortItem?.sort === 'asc';
        const isSortedDesc = sortItem?.sort === 'desc'
        return (
          <div>
            <span className="table-card-title">{params.colDef.headerName}</span>
            {isSortedAsc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px', color: '#999999'}} /></span> : isSortedDesc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px', color: '#999999'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px'}} /></span> : <span className=""><RiExpandUpDownLine /></span>}
          </div>
        )
      },
      renderCell: (params) => {
        const value = params.value;
        if (value === null || value === undefined || value === '') {
          return (
            <Box display="flex" alignItems="center" justifyContent="center" style={{
              color: '#999', 
              fontStyle: 'italic'
            }}>
              N/A
            </Box>
          );
        }
        
        // Handle various boolean representations from API
        const isTrue = String(value).toLowerCase() === 'true' || value === true || value === 1;
        
        return (
          <Box display="flex" alignItems="center" justifyContent="center">
            {isTrue ? 'Yes' : 'No'}
          </Box>
        );
      },
      editable: false,
    } :     
    {
      field: "largeReport",
      type: "text",
      headerName: "Large Report",
      minWidth: 200,
      headerAlign: "left",
      align: "left",
      hideSortIcons: true,
      renderHeader: (params) => {
        const sortItem = sortModel.find(
            (item: any) => item.field === 'largeReport'
          );
    
        const isSortedAsc = sortItem?.sort === 'asc';
        const isSortedDesc = sortItem?.sort === 'desc'
        return (
          <div>
            <span className="table-card-title">{params.colDef.headerName}</span>
            {isSortedAsc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px', color: '#999999'}} /></span> : isSortedDesc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px', color: '#999999'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px'}} /></span> : <span className=""><RiExpandUpDownLine /></span>}
          </div>
        )
      },
      renderCell: (params) => {
        const value = params.value;
        if (value === null || value === undefined || value === '') {
          return (
            <Box display="flex" alignItems="center" justifyContent="center" style={{
              color: '#999', 
              fontStyle: 'italic'
            }}>
              N/A
            </Box>
          );
        }
        
        // Handle various boolean representations from API
        const isTrue = String(value).toLowerCase() === 'true' || value === true || value === 1;
        
        return (
          <Box display="flex" alignItems="center" justifyContent="center">
            {isTrue ? 'Yes' : 'No'}
          </Box>
        );
      },
      editable: false,
    }),
    // Large Report Fee column - only show when there's a fee value
    {
      field: "largeReportFee",
      type: "text",
      headerName: "Large Report Fee",
      minWidth: 190,
      headerAlign: "right",
      align: "right",
      hideSortIcons: true,
      renderHeader: (params) => {
        const sortItem = sortModel.find(
            (item: any) => item.field === 'largeReportFee'
          );
    
        const isSortedAsc = sortItem?.sort === 'asc';
        const isSortedDesc = sortItem?.sort === 'desc'
        return (
          <div>
            <span className="table-card-title">{params.colDef.headerName}</span>
            {isSortedAsc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px', color: '#999999'}} /></span> : isSortedDesc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px', color: '#999999'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px'}} /></span> : <span className=""><RiExpandUpDownLine /></span>}
          </div>
        )
      },
      renderCell: (params) => {
        const value = params.value;
        if (!value || value === 0 || value === '0' || value === '') {
          return (
            <Box display="flex" alignItems="center" justifyContent="center" style={{
              color: '#999', 
              fontStyle: 'italic'
            }}>
              -
            </Box>
          );
        }
        
        return (
          <Box display="flex" alignItems="center" justifyContent="center">
            {formatPrice(value)}
          </Box>
        );
      },
      editable: false,
    }, 
    {
      field: "wetSignature",
      type: "text",
      headerName: "Wet Signature Required",
      minWidth: 200,
      headerAlign: "left",
      align: "left",
      hideSortIcons: true,
      hide: true,
      renderHeader: (params) => {
        const sortItem = sortModel.find(
            (item: any) => item.field === 'wetSignature'
          );
    
        const isSortedAsc = sortItem?.sort === 'asc';
        const isSortedDesc = sortItem?.sort === 'desc'
        return (
          <div>
            <span className="table-card-title">{params.colDef.headerName}</span>
            {isSortedAsc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px', color: '#999999'}} /></span> : isSortedDesc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px', color: '#999999'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px'}} /></span> : <span className=""><RiExpandUpDownLine /></span>}
          </div>
        )
      },
      valueGetter: (params) => params.value,
      editable: true, // Make the feeDue column editable
    },
    {
      field: "notaryStamp",
      type: "text",
      headerName: "Notary Stamp Required",
      minWidth: 200,
      headerAlign: "left",
      align: "left",
      hideSortIcons: true,
      hide: true,
      renderHeader: (params) => {
        const sortItem = sortModel.find(
            (item: any) => item.field === 'notaryStamp'
          );
    
        const isSortedAsc = sortItem?.sort === 'asc';
        const isSortedDesc = sortItem?.sort === 'desc'
        return (
          <div>
            <span className="table-card-title">{params.colDef.headerName}</span>
            {isSortedAsc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px', color: '#999999'}} /></span> : isSortedDesc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px', color: '#999999'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px'}} /></span> : <span className=""><RiExpandUpDownLine /></span>}
          </div>
        )
      },
      valueGetter: (params) => params.value,
      editable: true, // Make the feeDue column editable
    },
    {
      field: "feeDue",
      type: "text",
      headerName: "Fee Due",
      minWidth: 140,
      headerAlign: "right",
      align: "right",
      hideSortIcons: true,
      renderHeader: (params) => {
        const sortItem = sortModel.find(
            (item: any) => item.field === 'feeDue'
          );
    
        const isSortedAsc = sortItem?.sort === 'asc';
        const isSortedDesc = sortItem?.sort === 'desc'
        return (
          <div>
            <span className="table-card-title">{params.colDef.headerName}</span>
            {isSortedAsc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px', color: '#999999'}} /></span> : isSortedDesc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px', color: '#999999'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px'}} /></span> : <span className=""><RiExpandUpDownLine /></span>}
          </div>
        )
      },
      valueGetter: (params) =>
        formatPrice(typeof params.value === 'string' ? params.value : String(params.value)),
      editable: false,
    },
  ];

  const handleRowEditCommit = (row: any) => {
    let updatedRow = row.row
    let AllRec = [...listData];
    let exsistinfRec = AllRec.find(x => x.rowNum === updatedRow.rowNum);
    if (exsistinfRec != undefined) {
      exsistinfRec.feeDue = updatedRow.feeDue;
      setItemList(AllRec);
    }

    return updatedRow;
  };

  return (
    <>
      <Box
        sx={{
          height: "calc(100vh - 300px)",
          display: "flex",
          flexDirection: "column",
          width: "100%",
          borderRadius: "12px",
          overflow: "hidden",
          boxShadow: "0 4px 24px rgba(15, 23, 42, 0.08), 0 1px 3px rgba(15, 23, 42, 0.06)",
          border: "1px solid #e2e8f0",
          backgroundColor: "#ffffff",
        }}
      >
        {isLoading || loadingData && (
          <>
            <Box
                position="absolute"
                top={0}
                left={0}
                right={0}
                bottom={0}
                display="flex"
                alignItems="center"
                justifyContent="center"
                sx={{
                    backgroundColor: "rgba(250, 251, 252, 0.85)",
                    zIndex: 10,
                    border: "1px solid #e2e8f0",
                    borderRadius: 1,
                }}
            >
                <Box sx={{ width: "100%", maxWidth: 320 }}>
                    <LinearProgress color="info" sx={{ backgroundColor: "#e2e8f0", "& .MuiLinearProgress-bar": { backgroundColor: "#132D3D" } }} />
                    <Box sx={{ mt: 1.5, textAlign: "center" }}>
                        <span style={{ fontSize: "14px", fontWeight: 600, color: "#475569" }}>Loading...</span>
                    </Box>
                </Box>
            </Box>
          </>
        )}
        <div style={{ flex: "1 1 0%", overflow: "auto" }}>
          <DataGridPro
            apiRef={stateReportBillingGridApiRef}
            rowHeight={60}
            getRowId={(r) => r.rowNum}
            rows={listData}
            columns={Columns}
            loading={isLoading || loadingData}
            pageSize={pageSize}
            pagination
            rowCount={totalCount || 0}
            paginationMode="server"
            onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
            page={currentPage - 1}
            onPageChange={(newPage) => setCurrentPage(newPage + 1)}
            rowsPerPageOptions={getRowsPerPageOptions(totalCount, pageSize)}
            editMode="row"
            onRowEditStop={handleRowEditCommit}
            checkboxSelection={
              user?.userRoles.split(",").includes("Super Admin") ? true : false
            }
            filterMode="server"
            onFilterModelChange={setFilterModel}
            sortingMode="server"
            sortingOrder={["asc", "desc"]}
            sortModel={sortModel}
            onSortModelChange={setSortModel}
            selectionModel={
              selectedRows?.map((item) => item.rowNum).filter((rowNum): rowNum is Exclude<typeof rowNum, undefined> => rowNum !== undefined) || []
            }
            onSelectionModelChange={
              user?.userRoles.split(",").includes("Super Admin")
                ? (newRowSelectionModel) => {
                    onRowsSelectionHandler(newRowSelectionModel);
                  }
                : undefined
            }
            components={{
              Toolbar: EditToolbar,
              ColumnMenu: CustomColumnMenu,
            }}
            sx={{
              fontFamily: '"Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
              border: "none",
              fontSize: "14px",
              color: "#475569",
              backgroundColor: "#ffffff",
              "& .MuiDataGridPro-columnHeaderTitle": {
                whiteSpace: "normal",
                lineHeight: 1.35,
                fontWeight: 600,
                fontSize: "12px",
                letterSpacing: "0.05em",
                textTransform: "uppercase",
                color: "#64748b",
              },
              "& .MuiDataGrid-columnHeaders": {
                backgroundColor: "#f8fafc",
                borderBottom: "2px solid #e2e8f0",
                borderTop: "2px solid #e2e8f0",
                minHeight: "52px !important",
                maxHeight: "52px !important",
              },
              "& .MuiDataGrid-columnHeader": {
                "&:focus, &:focus-within": { outline: "none" },
              },
              "& .MuiDataGrid-row": {
                transition: "background-color 0.15s ease",
                "&:nth-of-type(even)": {
                  backgroundColor: "#fafbfc",
                },
                "&:hover": {
                  backgroundColor: "#f1f5f9 !important",
                },
                "&.Mui-selected": {
                  backgroundColor: "#ebf5fa !important",
                  "&:hover": {
                    backgroundColor: "#dbeef7 !important",
                  },
                },
              },
              "& .MuiDataGrid-cell": {
                borderBottom: "1px solid #f1f5f9",
                fontSize: "14px",
                color: "#334155",
                "&:focus": { outline: "none" },
              },
              "& .MuiDataGrid-virtualScroller": {
                border: "none",
              },
              "& .MuiDataGrid-main": {
                border: "none",
              },
              "& .MuiDataGrid-footerContainer": {
                borderTop: "1px solid #e2e8f0",
                backgroundColor: "#f8fafc",
                minHeight: 56,
              },
              "& .MuiTablePagination-root": {
                color: "#64748b",
                fontSize: "13px",
              },
              "& .MuiTablePagination-selectLabel, & .MuiTablePagination-displayedRows": {
                marginBottom: 0,
              },
              "& .MuiTablePagination-select": {
                fontSize: "13px",
                borderRadius: "6px",
                border: "1px solid #e2e8f0",
              },
              "& .MuiIconButton-root": {
                color: "#64748b",
                "&:hover": {
                  backgroundColor: "#f1f5f9",
                  color: "#475569",
                },
              },
              "& .MuiCheckbox-root": {
                color: "#94a3b8",
                "&.Mui-checked": {
                  color: "#2099d2",
                },
              },
            }}
          />
        </div>
        <EditStateReport handleClose={handleClose} Open={OpenEdit} StateRuleMatrixCL={Formdata} handleSubmit={handleSubmitAndRefresh} initValues={initialLBData} isStateReport={false} />
      </Box>
    </>
  );
}
